
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

type AccessDeniedProps = {
  message: string;
  description: string;
  onReturn: () => void;
};

export const AccessDenied = ({ message, description, onReturn }: AccessDeniedProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{message}</CardTitle>
        <CardDescription>
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p>Veuillez retourner à votre tableau de bord.</p>
      </CardContent>
      <CardFooter>
        <Button onClick={onReturn}>
          Retour au tableau de bord
        </Button>
      </CardFooter>
    </Card>
  );
};
